/**
 * web.js — adapter web dell'app Capacitor.
 *
 * Caricato SOLO dalla shell PHP (frontend/capp/route.php) quando l'app è
 * servita sui domini canale con window.TY_WEB = true. Sul nativo
 * (mobileapp.teyuto.tv) questo file non viene mai incluso: tutto ciò che sta
 * qui è per definizione a impatto zero sull'app mobile.
 *
 * Responsabilità:
 *  1. shim dei plugin nativi minimi usati da codice condiviso (toast)
 *  2. deep-link iniziale dagli URL SEO (/video?w=, /collection?s=, /page...)
 *  3. header + footer desktop (>=992px), minimali: logo, pagine custom,
 *     ricerca, salvati, profilo
 *  4. piccole correzioni web (anchor href="#" con <base>, indicatore navbar)
 */

/* ------------------------------------------------------------------ *
 * 0. Sessione web: il cookie teyuto_session è la fonte di verità
 * ------------------------------------------------------------------ */
// Sul web il token vive nel cookie (come nella webapp): lo si riversa SUBITO
// (parse time, prima del deviceready finto) sia nella variabile globale
// userToken sia nella tabella `info` emulata su localStorage, così il boot di
// app.js — che legge il token dallo shim SQLite — lo trova anche dopo un
// localStorage.clear() fatto in una sessione precedente.
(function () {
    var m = document.cookie.match(/(?:^|;\s*)teyuto_session=([^;]+)/);
    if (!m) return;
    var tok = decodeURIComponent(m[1]);
    try { userToken = tok; } catch (e) {}
    try {
        var info = JSON.parse(localStorage.getItem('ty_websql_info')) || {};
        info.token = tok;
        localStorage.setItem('ty_websql_info', JSON.stringify(info));
    } catch (e) {}
})();

/* ------------------------------------------------------------------ *
 * 1. Shim plugin nativi
 * ------------------------------------------------------------------ */
window.plugins = window.plugins || {};
if (!window.plugins.toast) {
    window.plugins.toast = (function () {
        function show(message) {
            var el = document.createElement('div');
            el.className = 'ty-web-toast';
            el.textContent = message;
            document.body.appendChild(el);
            requestAnimationFrame(function () { el.classList.add('ty-web-toast-visible'); });
            setTimeout(function () {
                el.classList.remove('ty-web-toast-visible');
                setTimeout(function () { el.remove(); }, 300);
            }, 2600);
        }
        return {
            showShortBottom: show,
            showLongBottom: show,
            showShortTop: show,
            showLongTop: show,
            show: show
        };
    })();
}

/* ------------------------------------------------------------------ *
 * 2. Deep-link iniziale dagli URL SEO
 * ------------------------------------------------------------------ */

// Route gestite dai moduli web opzionali (auth e pagamenti): il match è per
// prefisso sul pathname; il dispatch delega ai rispettivi router helper.
var TY_WEB_AUTH_PATHS = ['/login', '/register', '/passwordRecover', '/newPassword', '/twofa', '/emailConfirmation', '/mytv'];
var TY_WEB_PAY_PATHS = ['/checkout-cart', '/checkout', '/paymentPreview', '/paymentGiftcard', '/giftcard_redeem', '/giftcard', '/thankyou', '/payments'];

function tyWebPathIn(path, list) {
    return list.some(function (p) { return path.indexOf(p) === 0; });
}

// Chiamato da mobile.js al posto di navigateToPage('home') quando TY_WEB:
// mostra subito la home come layer di base, poi — quando i dati company sono
// pronti — apre il contenuto puntato dall'URL della shell.
function tyWebInitialRoute() {
    // URL letto PRIMA della home: se Nav è già avviato, navigateToPage('home')
    // fa push di '/' e il deep-link andrebbe perso
    var path = window.location.pathname;
    var qs = new URLSearchParams(window.location.search);

    // link legacy della vecchia webapp (/app/newPassword, /app/login, … nelle
    // email già inviate): stesso routing senza il prefisso /app
    if (path === '/app' || path.indexOf('/app/') === 0) {
        path = path.slice(4) || '/';
    }

    navigateToPage('home');

    // nota: '/shorts' (feature rimossa) non viene più dispatchato: un vecchio
    // deep-link /shorts resta sulla home appena renderizzata sopra
    var needsDispatch =
        (path.indexOf('/video') === 0 && qs.get('w')) ||
        ((path.indexOf('/collection') === 0 || path.indexOf('/package') === 0) && qs.get('s')) ||
        (path.indexOf('/search') === 0) ||
        (path.indexOf('/explore') === 0) ||
        (path.indexOf('/saved') === 0) ||
        (path.indexOf('/playlist') === 0) ||
        (path.indexOf('/profile') === 0) ||
        (path.indexOf('/page') === 0 && qs.get('id_custom')) ||
        (tyWebPathIn(path, TY_WEB_AUTH_PATHS) && typeof tyWebAuthRoute === 'function') ||
        (tyWebPathIn(path, TY_WEB_PAY_PATHS) && typeof tyWebPaymentsRoute === 'function');

    if (!needsDispatch) return;

    // link diretto al carrello: l'attesa (dati canale + sessione Stripe)
    // deve essere evidente da subito, non una home che poi cambia pagina
    if ((path.indexOf('/checkout-cart') === 0 || path.indexOf('/checkout/cart') === 0) &&
        qs.get('idc') && typeof tyWebCheckoutLoading === 'function') {
        tyWebCheckoutLoading(true);
    }

    tyWebWhenReady(function () {
        if (tyWebPathIn(path, TY_WEB_AUTH_PATHS) && typeof tyWebAuthRoute === 'function') {
            tyWebAuthRoute(path, qs);
        } else if (tyWebPathIn(path, TY_WEB_PAY_PATHS) && typeof tyWebPaymentsRoute === 'function') {
            tyWebPaymentsRoute(path, qs);
        } else if (path.indexOf('/video') === 0 && qs.get('w')) {
            loadPageVideo(qs.get('w'));
        } else if (path.indexOf('/collection') === 0 || path.indexOf('/package') === 0) {
            openSerieThumb(qs.get('s'));
        } else if (path.indexOf('/search') === 0 || path.indexOf('/explore') === 0) {
            // categoria/tag: /search?idCat=&idTag=&name= (vedi Nav.urlFor);
            // /explore è il path della vecchia webapp, stessi parametri
            if (qs.get('idCat') || qs.get('idTag')) {
                clickedBrowseAll(qs.get('idCat') || '', qs.get('idTag') || '', qs.get('name') || '', false);
            } else {
                navigateToPage('search');
            }
        } else if (path.indexOf('/playlist') === 0 && qs.get('id')) {
            // pagina playlist condivisa (vista pubblica)
            openSharedPlaylist(qs.get('id'));
        } else if (path.indexOf('/saved') === 0 || path.indexOf('/playlist') === 0) {
            navigateToPage('saved');
        } else if (path.indexOf('/profile') === 0) {
            navigateToPage('profile');
        } else if (path.indexOf('/page') === 0 && qs.get('id_custom')) {
            openCustomPageLayer(qs.get('id_custom'));
        }
    });
}

// Esegue fn quando i dati del canale sono stati caricati (processCompanyData)
// E le traduzioni sono pronte (LANGUAGE_LINES) — altrimenti i render da
// deep-link escono con le label in fallback inglese. Dopo ~4s senza
// traduzioni si procede comunque (meglio il fallback che il blocco).
function tyWebWhenReady(fn) {
    var tries = 0;
    (function wait() {
        var companyOk = (typeof companyId !== 'undefined' && companyId);
        var langOk = (typeof LANGUAGE_LINES !== 'undefined' && LANGUAGE_LINES);
        if (companyOk && (langOk || tries > 40)) {
            fn();
        } else if (++tries < 300) { // max ~30s
            setTimeout(wait, 100);
        }
    })();
}

/* ------------------------------------------------------------------ *
 * 3. Header + footer desktop
 * ------------------------------------------------------------------ */

// Esegue fn quando i dati utente sono stati caricati (updateUserInfo);
// se l'utente non è loggato, fn viene chiamata comunque con userData vuoto.
function tyWebWhenUser(fn) {
    var tries = 0;
    (function wait() {
        if (typeof userData !== 'undefined' && userData !== null) {
            fn();
        } else if (++tries < 300) {
            setTimeout(wait, 100);
        }
    })();
}

function tyWebIsUserLogged() {
    return typeof userData !== 'undefined' && !!userData && userData.status == 'success';
}

// pagine custom per header (top) e footer (bottom) — come la webapp
// (companySettings.pages.top/bottom); fallback sulla lista generica
function tyWebPagesTop() {
    try { if (companySettings.pages && companySettings.pages.top) return companySettings.pages.top; } catch (e) {}
    return companyCustomHomePages || [];
}
function tyWebPagesBottom() {
    try { if (companySettings.pages && companySettings.pages.bottom) return companySettings.pages.bottom; } catch (e) {}
    return [];
}

// stato attivo delle voci header: una sola pillola bianca alla volta;
// la voce Categorie torna alla label di default quando si va altrove
function tyWebNavReset() {
    $('.ty-web-nav > div, .ty-web-nav-more-menu > div').removeClass('active');
    var catLbl = document.getElementById('ty-web-cat-label');
    if (catLbl) catLbl.textContent = translate('CATEGORIES');
    tyWebNavFitSoon();
}

function tyWebNavSelect(el) {
    tyWebNavReset();
    // la voce può stare nel nav o nel menu "altro" (vedi tyWebNavFit)
    if (el) $(el).closest('.ty-web-nav-more-menu > div, .ty-web-nav > div').addClass('active');
}

// ---- voci che non ci stanno: menu "altro" (⋯) in fondo al nav ----
// Le voci in eccesso passano, dall'ultima verso sinistra, nel dropdown
// #ty-web-nav-more; restano gli stessi nodi (id e onclick invariati), cambia
// solo lo stile (.ty-web-dd-item). Il dropdown Categorie resta sempre nel
// nav (un sottomenu dentro il menu non si aprirebbe bene), e così la prima voce.
var tyWebNavItems = [];
var tyWebNavFitFrame = null;

function tyWebNavFit() {
    var nav = document.getElementById('ty-web-nav');
    var more = document.getElementById('ty-web-nav-more');
    if (!nav || !more) return;
    var menu = more.querySelector('.ty-web-dd-menu');

    // tutte le voci di nuovo nel nav, nell'ordine originale
    tyWebNavItems.forEach(function (item) {
        item.classList.remove('ty-web-dd-item');
        nav.insertBefore(item, more);
    });
    more.style.display = 'none';

    // sotto i 992px l'header è nascosto: niente da misurare
    if (!nav.clientWidth || nav.scrollWidth <= nav.clientWidth) return;

    more.style.display = '';
    for (var i = tyWebNavItems.length - 1; i > 0 && nav.scrollWidth > nav.clientWidth; i--) {
        var item = tyWebNavItems[i];
        if (item.classList.contains('ty-web-dd') || item.style.display === 'none') continue;
        item.classList.add('ty-web-dd-item');
        menu.insertBefore(item, menu.firstChild);
    }
    if (!menu.children.length) more.style.display = 'none';
}

// testo/peso delle voci, logo e azioni cambiano la larghezza: un solo
// ricalcolo per frame anche se chiamato più volte di fila
function tyWebNavFitSoon() {
    if (tyWebNavFitFrame) return;
    tyWebNavFitFrame = requestAnimationFrame(function () {
        tyWebNavFitFrame = null;
        tyWebNavFit();
    });
}

// marca la voce Categorie come attiva col NOME della categoria al posto
// della label (si ripristina scegliendo altro). Usata sia dal dropdown sia
// dai click categoria dentro la pagina search (via clickedBrowseAll).
function tyWebNavMarkCategory(name) {
    tyWebNavReset();
    var dd = document.getElementById('ty-web-nav-categories');
    if (dd) {
        dd.classList.add('active');
        var lbl = document.getElementById('ty-web-cat-label');
        if (lbl && name) lbl.textContent = name;
    }
}

// click su una categoria dal dropdown: marca la voce e chiude il menu hover
function tyWebNavSelectCategory(item, id, name) {
    tyWebNavMarkCategory(name);
    var dd = document.getElementById('ty-web-nav-categories');
    if (dd) {
        // chiude il dropdown hover finché il mouse non ci ripassa
        var menu = dd.querySelector('.ty-web-dd-menu');
        if (menu) {
            menu.style.display = 'none';
            setTimeout(function () { menu.style.display = ''; }, 350);
        }
    }
    clickedBrowseAll(id, null, name, false);
}

function tyWebOpenCustomPage(pageId) {
    if (pageId) {
        // entry propria nella history con URL SEO /page?id_custom=…
        openCustomPageLayer(pageId);
    } else {
        currentCustomPageActive = 'user';
        destroyHomePage();
        navigateToPage('home');
    }
    tyWebNavReset();
    $('#ty-web-page-' + (pageId || 'user')).addClass('active');
}

// true se il colore (hex) è chiaro: il testo del chrome va scelto per
// CONTRASTO con lo sfondo del canale, non con companyTextColor (pensato per
// altri usi e non affidabile qui — su WeShort è scuro su fondo scuro)
function tyWebIsLightColor(hex) {
    try {
        var n = String(hex).replace('#', '');
        if (n.length === 3) n = n.split('').map(function (c) { return c + c; }).join('');
        var r = parseInt(n.slice(0, 2), 16);
        var g = parseInt(n.slice(2, 4), 16);
        var b = parseInt(n.slice(4, 6), 16);
        return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
    } catch (e) {
        return false;
    }
}

function tyWebBuildChrome() {
    if (document.querySelector('.ty-web-header')) return;

    var bg = companyBackgroundColor || '#000000';
    var primary = companyPrimaryColor || '#ffffff';
    // testo del chrome per contrasto con lo sfondo; !important per battere
    // i css ereditati della piattaforma (main.css & co.)
    var chromeText = tyWebIsLightColor(bg) ? '#111111' : '#ffffff';
    var logged = tyWebIsUserLogged();

    // tema: colori del canale applicati al chrome web
    var style = document.createElement('style');
    style.id = 'ty-web-theme';
    style.textContent =
        // header trasparente al top; dopo lo scroll: velo del colore canale
        // semi-trasparente + backdrop blur (il blur è in web.css)
        '.ty-web-header{color:' + chromeText + ' !important;}' +
        '.ty-web-header.ty-web-header-solid{background:color-mix(in srgb, ' + bg + ' 62%, transparent);}' +
        '.ty-web-footer{background:' + bg + ';}' +
        // il dropdown è vetro liquid glass (fondo e blur in web.css), quindi
        // sempre scuro: testo bianco a prescindere dal colore del canale
        '.ty-web-dd-item{color:#ffffff !important;}' +
        '.ty-web-nav > div > .ty-web-nav-label{color:' + chromeText + ' !important;}' +
        // voce attiva a "pillola" (stile Netflix): sfondo a contrasto,
        // testo del colore dello sfondo header
        '.ty-web-nav > div.active{background:' + chromeText + ';}' +
        '.ty-web-nav > div.active > .ty-web-nav-label{color:' + bg + ' !important;}' +
        '.ty-web-nav > div:not(.active):hover{background:rgba(128,128,128,.18);}' +
        // voce attiva finita nel menu "altro": la pillola va sui tre puntini
        '.ty-web-nav > .ty-web-nav-more:has(> .ty-web-dd-menu > .active){background:' + chromeText + ';}' +
        '.ty-web-nav > .ty-web-nav-more:has(> .ty-web-dd-menu > .active) > .ty-web-nav-label{color:' + bg + ' !important;}' +
        '.ty-web-action{color:' + chromeText + ' !important;}' +
        '.ty-web-header .ty-web-lang{color:' + chromeText + ' !important;}' +
        '.ty-web-btn-secondary{color:' + chromeText + ' !important;}' +
        '.ty-web-logo-label{color:' + chromeText + ' !important;}' +
        // footer: stessi colori a contrasto (bianco sui canali scuri)
        '.ty-web-footer, .ty-web-footer a, .ty-web-footer .link-footer-a, .ty-web-footer .social-link-a, .ty-web-footer .social-link-a i, .ty-web-footer .ty-web-footer-text, .ty-web-footer .companyInfo, .ty-web-footer .ty-web-footer-copy, .ty-web-footer .ty-web-lang{color:' + chromeText + ' !important;}' +
        // testo del bottone primario per CONTRASTO col suo sfondo (primary
        // chiaro → testo scuro, come le pillole del nav)
        '.ty-web-btn-primary{background:' + primary + ';border-color:' + primary + ';color:' + (tyWebIsLightColor(primary) ? '#111111' : '#ffffff') + ' !important;}';
    document.head.appendChild(style);

    var logoHtml = companyLogo
        ? '<img class="ty-web-logo-img" src="' + companyLogo + '" alt="' + (companyName || '') + '" onerror="this.style.display=\'none\'">'
        : '<span class="ty-web-logo-label">' + (companyName || '') + '</span>';

    var header =
        '<header class="header ty-web-header">' +
            '<div class="ty-web-header-inner">' +
                '<a class="ty-web-logo" href="/" onclick="event.preventDefault(); tyWebOpenCustomPage(null); return false;">' + logoHtml + '</a>' +
                '<nav class="ty-web-nav header-menu" id="ty-web-nav"></nav>' +
                '<div class="ty-web-actions navbar-right-items" id="ty-web-actions"></div>' +
            '</div>' +
        '</header>';

    $('body').prepend(header).addClass('ty-web');

    // sfondo dell'header solo quando si scrolla (al top resta trasparente)
    var headerEl = document.querySelector('.ty-web-header');
    function tyWebHeaderOnScroll() {
        if (window.scrollY > 24) {
            headerEl.classList.add('ty-web-header-solid');
        } else {
            headerEl.classList.remove('ty-web-header-solid');
        }
    }
    window.addEventListener('scroll', tyWebHeaderOnScroll, { passive: true });
    tyWebHeaderOnScroll();

    tyWebBuildNav();
    tyWebBuildActions();
    tyWebBuildFooter();

    // l'item download è nascosto via CSS: il pill indicator va ricalcolato
    try { updateNavIndicator(false); } catch (e) {}
}

// ---- nav principale: Home (+ pagine custom), Categorie, Salvati ----
function tyWebBuildNav() {
    var $nav = $('#ty-web-nav');
    if (!$nav.length) return;

    var logged = tyWebIsUserLogged();
    var showGuestMenu = true;
    try {
        if (!logged && companySettings.show_search_guest == false) showGuestMenu = false;
    } catch (e) {}

    // ordine voluto: Home, Categorie, Preferiti, poi le pagine custom "top"
    // nel loro ordine di configurazione
    var html = '';

    if (showGuestMenu) {
        html += '<div class="active" id="ty-web-page-user" onclick="tyWebOpenCustomPage(null);"><span class="ty-web-nav-label">' + translate('HOME') + '</span></div>';

        // Categorie (sottomenu riempito via API)
        html += '<div class="ty-web-dd" id="ty-web-nav-categories" style="display:none;">' +
                    '<span class="ty-web-nav-label"><span id="ty-web-cat-label">' + translate('CATEGORIES') + '</span> <i class="ri-arrow-down-s-line"></i></span>' +
                    '<div class="ty-web-dd-menu" id="ty-web-categories-menu"></div>' +
                '</div>';
    }

    if (logged) {
        html += '<div onclick="tyWebNavSelect(this);navigateToPage(\'saved\');"><span class="ty-web-nav-label">' + translate('BROWSE_SAVED') + '</span></div>';
    }

    if (showGuestMenu) {
        // pagine custom "top" come voci dirette (Gift Card, Subscribe, ecc.)
        tyWebPagesTop().forEach(function (page) {
            var pTitle = '';
            try { pTitle = getCurrentStringML(page.title || '', currentLang); } catch (e) { pTitle = page.title || ''; }
            html += '<div id="ty-web-page-' + page.id + '" onclick="tyWebOpenCustomPage(\'' + page.id + '\');"><span class="ty-web-nav-label">' + pTitle + '</span></div>';
        });
    }

    // menu "altro": riempito da tyWebNavFit con le voci che non ci stanno
    html += '<div class="ty-web-dd ty-web-nav-more" id="ty-web-nav-more" style="display:none;" title="' + translate('MORE') + '">' +
                '<span class="ty-web-nav-label"><i class="ri-more-fill"></i></span>' +
                '<div class="ty-web-dd-menu ty-web-nav-more-menu"></div>' +
            '</div>';

    $nav.html(html);
    tyWebNavItems = $nav.children().not('#ty-web-nav-more').get();

    // scelta una voce il menu hover si chiude finché il mouse non ci ripassa
    var moreMenu = $nav.find('.ty-web-nav-more-menu')[0];
    moreMenu.addEventListener('click', function () {
        moreMenu.style.display = 'none';
        setTimeout(function () { moreMenu.style.display = ''; }, 350);
    });

    tyWebNavFitSoon();
    window.addEventListener('resize', tyWebNavFitSoon);
    // logo e azioni a destra cambiano lo spazio del nav senza resize
    try { new ResizeObserver(tyWebNavFitSoon).observe($nav[0]); } catch (e) {}
    try { document.fonts.ready.then(tyWebNavFitSoon); } catch (e) {}

    if (showGuestMenu) {
        tyWebLoadCategoriesMenu();
    }
}

function tyWebLoadCategoriesMenu() {
    $.ajax({
        type: 'GET',
        url: URL_API + '/categories/?f=get_categories',
        success: function (json) {
            var obj;
            try { obj = (typeof json === 'string') ? JSON.parse(json) : json; } catch (e) { return; }
            if (!Array.isArray(obj) || obj.length === 0) return;
            var html = '';
            obj.forEach(function (cat) {
                if (!cat || !cat.id) return;
                // stesse categorie mostrate nel search: SOLO le pubbliche
                if (!(cat.show == 1 || cat.show == true)) return;
                var safeName = String(cat.name || '').replace(/'/g, "\\'");
                html += '<div class="ty-web-dd-item" onclick="tyWebNavSelectCategory(this, ' + cat.id + ', \'' + safeName + '\');">' + (cat.name || '') + '</div>';
            });
            if (html) {
                $('#ty-web-categories-menu').html(html);
                $('#ty-web-nav-categories').show();
                tyWebNavFitSoon();
            }
        }
    });
}

// ---- azioni a destra: ricerca, dashboard admin, avatar / login+register ----
function tyWebBuildActions() {
    var $actions = $('#ty-web-actions');
    if (!$actions.length) return;

    var logged = tyWebIsUserLogged();
    var showSearch = true;
    try {
        if (!logged && companySettings.show_search_guest == false) showSearch = false;
    } catch (e) {}

    var html = '';
    if (showSearch) {
        html += '<button type="button" class="ty-web-action" id="ty-web-action-search" title="' + translate('SEARCH') + '"><i class="ri-search-line"></i></button>';
    }

    if (logged) {
        if (userData.is_admin) {
            html += '<a class="ty-web-action" href="/dashboard" title="Dashboard"><i class="ri-dashboard-line"></i></a>';
        }
        html += '<img id="ty-web-avatar" class="ty-web-avatar avatar_bg img-round image-profile-general" src="' + (userData.profile_image || '') + '" onclick="navigateToPage(\'profile\');" onerror="this.style.display=\'none\';document.getElementById(\'ty-web-action-profile\').style.display=\'\';">' +
                '<button type="button" class="ty-web-action" id="ty-web-action-profile" style="display:none;" onclick="navigateToPage(\'profile\');" title="' + translate('PROFILE') + '"><i class="ri-user-3-line"></i></button>';
    } else {
        // guest: selettore lingua in header (parità webapp) + login/register.
        // NIENTE classi button-primary/secondary native: su mobile.css sono
        // full-width con padding grandi e qui deformerebbero l'header.
        html += tyWebLangSelectorHtml() +
                '<button type="button" class="ty-web-btn ty-web-btn-secondary" onclick="generateAndHandleNewToken(\'login\');">' + translate('LOGIN') + '</button>' +
                '<button type="button" class="ty-web-btn ty-web-btn-primary" onclick="generateAndHandleNewToken(\'register\');">' + translate('REGISTER') + '</button>';
    }
    $actions.html(html);

    $('#ty-web-action-search').on('click', function () {
        tyWebNavReset();
        navigateToPage('search');
        // focus diretto sull'input: si può digitare subito
        setTimeout(function () {
            try { $('.headerSearchGlobalInputMobile').trigger('focus'); } catch (e) {}
        }, 80);
    });
}

// select delle lingue del canale (riusato in header guest e footer)
function tyWebLangSelectorHtml() {
    try {
        if (!Array.isArray(companyLanguages) || companyLanguages.length <= 1) return '';
        var names = new Intl.DisplayNames([currentLang || 'en'], { type: 'language' });
        var opts = '';
        companyLanguages.forEach(function (code) {
            var label = code;
            try { label = names.of(code); } catch (e) {}
            opts += '<option value="' + code + '"' + (code === currentLang ? ' selected' : '') + '>' + label + '</option>';
        });
        return '<select class="language-select ty-web-lang" onchange="updateUserLanguage(this.value)">' + opts + '</select>';
    } catch (e) {
        return '';
    }
}

// ---- footer: logo, link pagine (tos/privacy/custom bottom), social,
//      selettore lingua, login/register per i guest, footer text, badge ----
function tyWebBuildFooter() {
    if (document.querySelector('.ty-web-footer')) return;

    var logged = tyWebIsUserLogged();
    var s = (typeof companySettings !== 'undefined' && companySettings) ? companySettings : {};

    // link pagine
    var links = '';
    try {
        if (typeof companyDocTos !== 'undefined' && companyDocTos) {
            links += '<a class="link-footer-a" href="' + companyDocTos + '" target="_blank" rel="noopener">' + translate('TERMS_AND_CONDITIONS') + '</a>';
        }
        if (typeof companyDocPrivacy !== 'undefined' && companyDocPrivacy) {
            links += '<a class="link-footer-a" href="' + companyDocPrivacy + '" target="_blank" rel="noopener">' + translate('PRIVACY_POLICY') + '</a>';
        }
    } catch (e) {}
    tyWebPagesBottom().forEach(function (page) {
        var pTitle = '';
        try { pTitle = getCurrentStringML(page.title || '', currentLang); } catch (e) { pTitle = page.title || ''; }
        links += '<a class="link-footer-a" onclick="tyWebOpenCustomPage(\'' + page.id + '\'); return false;" href="#">' + pTitle + '</a>';
    });

    // social
    var socials = '';
    var socialConfig = [
        { key: 'site', icon: 'ri-global-line' },
        { key: 'facebook', icon: 'ri-facebook-fill' },
        { key: 'linkedin', icon: 'ri-linkedin-fill' },
        { key: 'instagram', icon: 'ri-instagram-fill' },
        { key: 'twitter', icon: 'ri-twitter-x-fill' },
        { key: 'youtube', icon: 'ri-youtube-fill' },
        { key: 'tiktok', icon: 'ri-tiktok-fill' }
    ];
    var socialLinks = s.socials || {};
    socialConfig.forEach(function (soc) {
        if (socialLinks[soc.key]) {
            socials += '<a class="social-link-a" href="' + socialLinks[soc.key] + '" target="_blank" rel="noopener noreferrer"><i class="' + soc.icon + '"></i></a>';
        }
    });

    // selettore lingua (updateUserLanguage è di settings.js)
    var langSelector = tyWebLangSelectorHtml();

    // login/register per i guest
    var loginRow = '';
    if (!logged) {
        loginRow = '<div class="ty-web-footer-login">' +
            '<a onclick="generateAndHandleNewToken(\'register\'); return false;" href="#">' + translate('REGISTER') + '</a>' +
            '<a onclick="generateAndHandleNewToken(\'login\'); return false;" href="#">' + translate('LOGIN') + '</a>' +
        '</div>';
    }

    // badge Made in Teyuto (salvo debranding)
    var debranding = false;
    try { debranding = !!(typeof companyDebranding !== 'undefined' ? companyDebranding : s.debranding); } catch (e) {}
    var badge = '';
    if (!debranding) {
        badge = '<a class="ty-web-teyuto-badge" href="https://teyuto.com?ref=channel-badge&domain=' + window.location.hostname + '&name=' + encodeURIComponent(companyName || '') + '" target="_blank" rel="noopener">' +
            '<img src="/img/teyuto_icon.svg" alt="" class="teyuto-badge-icon"><img src="/img/made_in_teyuto.svg" alt="Made in Teyuto" class="teyuto-badge-text"></a>';
    }

    var logoHtml = companyLogo ? '<a href="/" onclick="event.preventDefault(); tyWebOpenCustomPage(null); return false;"><img class="ty-web-footer-logo" src="' + companyLogo + '" alt="' + (companyName || '') + '" onerror="this.style.display=\'none\'"></a>' : '';
    var footerText = s.footer_text ? '<div class="ty-web-footer-text companyInfo">' + s.footer_text + '</div>' : '';

    var footer =
        '<footer class="footer ty-web-footer" id="footer-web-page">' +
            '<div class="ty-web-footer-inner">' +
                '<div class="ty-web-footer-top">' + logoHtml + '</div>' +
                (links ? '<div class="ty-web-footer-links link-info">' + links + '</div>' : '') +
                '<div class="ty-web-footer-meta">' +
                    (socials ? '<div class="ty-web-footer-socials">' + socials + '</div>' : '') +
                    (langSelector ? '<div class="ty-web-footer-lang">' + langSelector + '</div>' : '') +
                '</div>' +
                loginRow +
                footerText +
                '<div class="ty-web-footer-bottom">' +
                    '<span class="ty-web-footer-copy">&copy; ' + new Date().getFullYear() + ' ' + (companyName || '') + '</span>' +
                    badge +
                '</div>' +
            '</div>' +
        '</footer>';

    $('body').append(footer);
}

/* ------------------------------------------------------------------ *
 * 4. Bootstrap web
 * ------------------------------------------------------------------ */
$(function () {
    // il default di <a href="#"> è bloccato in js/nav.js per ogni runtime

    // il chrome ha bisogno di company + traduzioni + stato utente (voci
    // guest/logged e label localizzate); dopo ~8s si costruisce comunque
    var chromeTries = 0;
    (function waitChrome() {
        var ready = false;
        try {
            ready = !!companyId &&
                typeof LANGUAGE_LINES !== 'undefined' && !!LANGUAGE_LINES &&
                typeof userData !== 'undefined' && userData !== null;
        } catch (e) {}
        if (ready || ++chromeTries > 80) {
            tyWebBuildChrome();
        } else {
            setTimeout(waitChrome, 100);
        }
    })();
});
